// extracted by mini-css-extract-plugin
module.exports = {"center":"center--2lrQ7","extra":"extra--PVX7W","resultTitle":"resultTitle--8GwKM"};